export default __webpack_public_path__ + "static/media/PopupCloseBtn.ee8133ae.svg";